export default "__VITE_ASSET__0C78BmeQ__"